module.exports = __webpack_public_path__ + "static/media/pen.cc7f6168.svg";